import { render, staticRenderFns } from "./InboxCounterPart.vue?vue&type=template&id=d5051046"
import script from "./InboxCounterPart.vue?vue&type=script&lang=js"
export * from "./InboxCounterPart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports